import { Link } from "react-router-dom"
import { Wrench } from "lucide-react"
import { useApiWithAuth } from "../hooks/useAuth.js"

// Floating dev-only shortcut to /dev-tools. Rendered ONLY in dev builds and
// only for superadmins — never present in a production bundle.
export default function DevToolsFab() {
  const { isSuperAdmin } = useApiWithAuth()

  if (!import.meta.env.DEV || !isSuperAdmin) return null

  return (
    <Link
      to="/dev-tools"
      aria-label="Ferramentas de dev"
      title="Ferramentas de dev"
      className="fixed bottom-24 right-4 z-[9999] flex items-center gap-2 rounded-full bg-main-purple px-4 py-3 text-white shadow-lg hover:bg-main-purple/90 active:scale-95 transition"
    >
      <Wrench size={18} />
      <span className="text-sm font-semibold">Dev</span>
    </Link>
  )
}
